import React, { useState, useEffect } from "react";
import CustomMap from "../../component/CustomMap";
import { X, Facebook, Instagram, Youtube, Timer, AlignLeft, Images, Hash, MapPinned, Map, CircleUserRound, Layers, FacebookIcon, InstagramIcon, YoutubeIcon, ArrowDownCircle, ArrowUpCircle, PhoneCallIcon, MailIcon, MapPin, MapPinCheck } from "lucide-react";
import VendorProfileCoupon from "./VendorProfileCoupon";
import { HTTP } from "../../api/http-common";
import { useParams } from 'react-router-dom';
import VendorGallery from "./VendorGallery";
import LocationCard from "../../component/LocationCard";
import '../../styling/vendorPage.css'
import { ElfsightWidget } from 'react-elfsight-widget';
import HeroBanner from "../../component/HeroBanner";
import { FaYoutube } from "react-icons/fa";
import { AiFillInstagram } from "react-icons/ai";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";
import { SlGlobe } from "react-icons/sl";
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';
import { useNavigate } from 'react-router-dom'
import BusinessCards from "../BusinessCards";
import LightGallery from 'lightgallery/react';
import { Link } from "react-router-dom";
import LocationCardNew from "../../component/LocationCardNew";
function VendorDetailsNew() {
  const navigate = useNavigate()
  const { id } = useParams();
  const [vendorData, setVendorData] = useState([]);
  const [vendorMediaList, setVendorMediaList] = useState([]);
  const [bannerImage, setBannerImage] = useState([]);
  const [showTimeDetails, setShowTimeDetails] = useState(null);
  const [locationDropDown, setlocationDropDown] = useState([])

  const [galleryList, setGalleryList] = useState([]);
  const [otherVendors, setOtherVendors] = useState([]);
  const [categoryName, setCategoryName] = useState(null);

  useEffect(() => {

    window.scrollTo(0, 0)
    
    const loadvendor = async () => {
      try {
        const response = await HTTP.get("vendors/profile/info/" + id);
        if (response.status === 200) {
          setVendorData(response.data.vendor_data);
          setVendorMediaList(response.data.vendor_media);
          setBannerImage(response.data.vendor_data.banner_image);
          setlocationDropDown(response.data.vendor_addresses);
          setCategoryName(response.data.vendor_data.category_name);
          // setOtherVendors(response.data.other_vendor_data)
          // You can log the response data, not the state variable (because state update is async)


          // Set banner image CSS rule
          if (response.data.vendor_data.banner_image) {
            const styleSheet = document.styleSheets[0];
            const rule = `
              .vendor-hero-bg::before {
                background-image: url('${response.data.vendor_data.banner_image}');
              }
            `;
            styleSheet.insertRule(rule, styleSheet.cssRules.length);
          }
        }
      } catch (error) {
        console.log(error);
        if (error.response && error.response.status === 401) {
          // Handle unauthorized error
        }
      }
    };
    // const otherVendorsData = async () => {
    //   try {
    //     let requestData = {
    //       filters: {
    //         // search_value: formData.searchValue || null,
    //         verification_status: 1,
    //         is_visible: true,
    //         id: id,
    //         category_name: categoryName,
    //         // plan_expiration_date: new Date().toISOString().split("T")[0]
    //       },
    //       pagination: {
    //         page: 1,
    //         limit: 3
    //       },
    //       sorting: {
    //         field: "",
    //         type: ""
    //       }
    //     };

    //     const response = await HTTP.post("/vendors/list", requestData);

    //     if (response.status === 200) {
    //       setOtherVendors(response.data.contents);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching active vendors:", error);
    //   }
    // }
    const loadGalleryList = async () => {
      const access_token = localStorage.getItem('access_token');
      const config = {
        headers: { 'Content-Type': 'application/json', token: access_token },
      };
      let fields = {};

      HTTP.post('/user/media_gallery/list', fields, config)
        .then((response) => {
          const data = response.data;
          if (response.status === 200) {
            setGalleryList(data.contents);
          }
          console.log('data for image', data);
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            localStorage.clear();
            navigate('/'); // Redirect to login page
          }
        });
    };
    // loadGalleryList();
    loadvendor();
    // otherVendorsData();
  }, [id]); // Only re-run if id changes

  useEffect(() => {
    if (!categoryName) return; // Prevent API call if categoryName is still null

    const otherVendorsData = async () => {
      try {
        let requestData = {
          filters: {
            verification_status: 1,
            is_visible: true,
            id: id,
            category_name: categoryName,
            plan_expiration_date: new Date().toISOString().split("T")[0]
          },
          pagination: { page: 1, limit: 3 },
          sorting: { field: "", type: "" },
        };

        const response = await HTTP.post("/vendors/list", requestData);

        if (response.status === 200) {
          setOtherVendors(response.data.contents);
        }
      } catch (error) {
        console.error("Error fetching active vendors:", error);
      }
    };

    otherVendorsData();
  }, [categoryName, id]);

  const toggleTimeList = (index) => {
    // If the clicked index is already open, close it by setting showTimeDetails to null
    if (showTimeDetails === index) {
      setShowTimeDetails(null);
    } else {
      // Otherwise, open the new location by setting the clicked index
      setShowTimeDetails(index);
    }
  };

  useEffect(() => {
    if (locationDropDown.length > 0) {
      // console.log('Updated locationDropDown:', locationDropDown);
      // You can perform actions with the updated locationDropDown here
    }
  }, [locationDropDown]);

  return (
    <>
      {/* <div className="bg-[#fcfcfc]"> */}
      {/* {Array.isArray(vendorMediaList) && vendorMediaList.length > 0 && ( */}
      <div className="vendor-slick-slider pb-2" >
        <div className="full-width-container my-4 relative">
          <div className="w-full">
            {vendorData.main_banner_image ? (
              <img
                src={vendorData.main_banner_image}
                className="vendor-gallery-wrapper object-cover"
                alt="profile-image"
              />
            ) : (
              <div className="vendor-gallery-wrapper flex justify-center items-center h-[470px]">
                <p>No images available</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* // )} */}
      <div className="new-vendor-detail-wrapper  w-[99%] mx-auto rounded-[12px]" >

        <div className="">
          <div className="">
            <div className="flex items-center">
              <div className="profile-image-container">
                <img src={vendorData.banner_image} alt="profile-image" />
              </div>
              <div>
                <p className="business-title text-white mb-0 leading-tight">
                  {vendorData.business_name || "BusinessName"}
                </p>
                <p className="vendor-hero-description text-white -mt-6">
                  {vendorData.short_description || "N/A"}
                </p>
              </div>
            </div>
          </div>
        </div>


      </div>

      <div className="">

      </div>
      <div className="w-full">
        <div className="container mx-auto">

          <div className="flex">

            <div className="w-1/2">
              <div className="description-conatiner card-structure"  >
                <div className="mini-card-header">
                  <span className="mini-card-icon">
                    <AlignLeft size={22} />
                  </span>
                  <h4 className="font-bold">Description</h4>
                </div>
                <div className="mini-card-body min-h-[300px] whitespace-pre-wrap">
                  {vendorData.business_description || "Description"}
                </div>
              </div>
              <div className="social-media-handlers-container card-structure"  >

                <div className="mini-card-header">
                  <span className="mini-card-icon">
                    <Hash size={22} />
                  </span>

                  <h4 className="font-bold">Social Media Handlers</h4>
                </div>
                <div className="mini-card-body">
                  <div className="vendor-social-media-icons flex items-center justify-center">
                    <a target={vendorData.x_url ? "_blank" : "_self"} href={`${vendorData.x_url == null ? '#' : (vendorData.x_url.startsWith('http') ? vendorData.x_url : `https://${vendorData.x_url}`)}`} className="mr-2 vendor-social-media-icon">
                      <FaSquareXTwitter size={25} />
                    </a>

                    <a target={vendorData.instagram ? "_blank" : "_self"} href={`${vendorData.instagram == null ? '#' : (vendorData.instagram.startsWith('http') ? vendorData.instagram : `https://${vendorData.instagram}`)}`} className="mr-2 vendor-social-media-icon">
                      <AiFillInstagram size={25} />
                    </a>

                    <a target={vendorData.youtube_url ? "_blank" : "_self"} href={`${vendorData.youtube_url == null ? '#' : (vendorData.youtube_url.startsWith('http') ? vendorData.youtube_url : `https://${vendorData.youtube_url}`)}`} className="mr-2 vendor-social-media-icon">
                      <FaYoutube size={25} />
                    </a>

                    <a target={vendorData.facebook_url ? "_blank" : "_self"} href={`${vendorData.facebook_url == null ? '#' : (vendorData.facebook_url.startsWith('http') ? vendorData.facebook_url : `https://${vendorData.facebook_url}`)}`} className="mr-2 vendor-social-media-icon">
                      <FaFacebookSquare size={25} />
                    </a>



                  </div>
                </div>


              </div>

            </div>
            <div className="w-1/2">

              <div className="business-contact-details-container card-structure"  >
                <div className="mini-card-header">
                  <span className="mini-card-icon">
                    <CircleUserRound size={24} />
                  </span>
                  <h4 className="font-bold">Contact Details</h4>
                </div>
                <div className="mini-card-body">
                  <div className="flexbox  justify-evenly flex-wrap">

                    <span className="flexbox justify-center mr-2 pb-4">
                      <span> <PhoneCallIcon size={20} className="text-[#6c24ff]  mr-2" /></span>
                      <span> <a href={` tel:${vendorData.phone_number == null ? '#' : vendorData.phone_number}`}>{vendorData.phone_number == null ? <span>N/A</span> : vendorData.phone_number}</a></span>
                      {/* console.log('number', response.data.phone_number); */}
                    </span>

                    <span className="flexbox justify-center mr-2 pb-4">
                      <span><MailIcon size={20} className="mr-2 text-[#6c24ff] " /></span>
                      <span> <a href={` mailto:${vendorData.email}`}>{vendorData.email == null ? <span>N/A</span> : vendorData.email}</a></span>
                    </span>
                    {vendorData.business_site_url && (
                      <span className="flexbox justify-center mr-2 pb-4">
                        <span><SlGlobe size={20} className="mr-2 text-[#6c24ff] " /></span>
                        <span> <a target="blank" href={`${vendorData.business_site_url == null ? '#' : vendorData.business_site_url}`}>Visit Us</a></span>
                      </span>
                    )}
                  </div>
                </div>

              </div>
              <div className="gallery-container card-structure" >
                <div className="mini-card-header">
                  <span className="mini-card-icon">
                    <Images size={24} />
                  </span>
                  <h4 className="font-bold">Gallery </h4>
                </div>
                <div className="mini-card-body">
                  <div className="vendor-image-preview-wrapper">
                    {vendorMediaList.length > 0 ? (
                      vendorMediaList.map((item, index) => (
                        <LightGallery
                          plugins={[lgZoom, lgVideo]}
                          mode="lg-fade"
                          pager={false}
                          thumbnail={true}
                          galleryId={'nature'}
                          autoplayFirstVideo={false}
                          elementClassNames={'gallery'}
                          mobileSettings={{
                            controls: false,
                            showCloseIcon: false,
                            download: false,
                            rotate: false,
                          }}
                        >
                          <img key={index} src={item.path} alt={item.title} />
                        </LightGallery>

                      ))
                    ) : (
                      <p>Images will be uploaded soon</p>
                    )}
                  </div>
                </div>
              </div>

              {locationDropDown
                .filter((location) => location.lat !== null && location.lng !== null)
                .map((location, index) => (
                  <div className="time-table-container card-structure" key={index} >
                    <div className="mini-card-header justify-between mb-0">
                      <div className="flex items-center">
                        <span className="mini-card-icon">
                          <MapPin size={24} />
                        </span>
                        <h4 className="font-bold text-[15px]">  {location.address},{location.city_name},{location.postal_code}</h4>
                      </div>
                      <div className="time-schedule-info flex items-center justify-between">
                        <span
                          className="mx-2 dropdown-icon"
                          onClick={() => toggleTimeList(index)} // Pass the index to the toggle function
                        >
                          {showTimeDetails === index ? (
                            <ArrowUpCircle size={24} />
                          ) : (
                            <ArrowDownCircle size={24} />
                          )}
                        </span>
                      </div>
                    </div>

                    <div>
                      <div
                        className={`overflow-hidden transition-all duration-300 ease-in-out ${showTimeDetails === index ? 'h-[340px]' : 'h-[0px]'
                          }`}
                      >
                        <div className="">
                          <div className="">
                            <div className="">
                              <LocationCardNew location={location} showTime={true} locationWrapper="padding-null-important" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

            </div>

          </div>
        </div>
      </div>

      <div className="container mx-auto" >

        <div className="py-6">
          <div className=" max-w-screen-xl mx-auto px-4">
            <div className="text-center">
              <h6 className="section-title " >
                Grab Your Deals Now
              </h6>

            </div>
          </div>
        </div>
        <div className="mx-2">
          <VendorProfileCoupon backgroundColor={true} />
        </div>
      </div>
      <div className="py-6 container max-w-screen-xl w-full" >
        <BusinessCards title="You May Also Be Interested In" data={otherVendors} />
      </div>


    </>
  );
}

export default VendorDetailsNew;
